import { useGetOfferQuery } from "api/TenantSlug/Offer/hooks.ts";
import { OfferFilterEditForm } from "components/Forms/OfferFilterEditForm/OfferFilterEditForm.tsx";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";

interface OfferFilterProps {
    offerId: string;
}

export const OfferFilter = ({ offerId }: OfferFilterProps) => {
    const { data, isLoading, isError } = useGetOfferQuery(offerId, { filter: { include: "forms,formStructures" } });
    const offer = data?.offer;

    if (!offer) {
        return <QueryState isLoading={isLoading} isError={isError || !isLoading} errorKey="errors.loading_offer" />;
    }

    return <OfferFilterEditForm offer={offer} />;
};
